import { module } from "angular";
import upgrade from "@gtmhub/core/upgrade/module";
import env from "@gtmhub/env/env.module";
import teamsCore from "@gtmhub/teams/teams-core.module";
import uiBootstrap from "@gtmhub/ui-bootstrap.module";
import {
  CommentComponent,
  CommentOptionsDropdownComponent,
  CommentsComponent as CommentsComponentMigrated,
  CommentsOrderingComponent,
  MentionsEditorComponent,
  ReactionsComponent,
  ShowCommentsButtonComponent,
} from "@webapp/comments";
import { CommentsComponent } from "./components/comments";
import { CommentService } from "./services/comment.service";
import { ReactionService } from "./services/reaction.service";

const mod = module("comments", [upgrade, env, uiBootstrap, teamsCore]);

mod.service("CommentService", CommentService);
mod.service("ReactionService", ReactionService);
mod.component("ghComments", CommentsComponent);

mod.downgradeComponent("mentionsEditor", { component: MentionsEditorComponent, propagateDigest: false });
mod.downgradeComponent("commentOptionsDropdown", { component: CommentOptionsDropdownComponent, propagateDigest: false });
mod.downgradeComponent("showCommentsButton", { component: ShowCommentsButtonComponent, propagateDigest: false });
mod.downgradeComponent("reactions", { component: ReactionsComponent, propagateDigest: false });
mod.downgradeComponent("comments", { component: CommentsComponentMigrated, propagateDigest: false });
mod.downgradeComponent("comment", { component: CommentComponent, propagateDigest: false });
mod.downgradeComponent("commentsOrdering", { component: CommentsOrderingComponent, propagateDigest: false });

export default mod.name;
